export const settings = {
	progsUrl: '/wp-json/fsgo/prog',
	notAllowedMobileStreamingTag: 'NFL'
};



// WEBPACK FOOTER //
// ./react-app-src/fsgo/constants.js